// extracted by mini-css-extract-plugin
module.exports = {"container":"EventsList_container__b6xG3","button":"EventsList_button__EhIsn"};